import React, { memo, useCallback } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { Icon } from '@alycecom/ui';
import { useCopyToClipboard } from 'react-use';
import { GlobalMessage, MessageType } from '@alycecom/services';

import StyledSubmitButton from '../../../../../components/Shared/StyledSubmitButton';

import WrongCountryProduct from './WrongCountryProduct';

export interface ICopySenderEmailFlowProps {
  productName: string;
  countryName: string;
  senderEmail: string;
}

const CopySenderEmailFlow = ({ productName, countryName, senderEmail }: ICopySenderEmailFlowProps): JSX.Element => {
  const [, copy] = useCopyToClipboard();
  const { showGlobalMessage } = GlobalMessage.useGlobalMessage();
  const handleCopySenderEmail = useCallback(() => {
    copy(senderEmail);
    showGlobalMessage({ type: MessageType.Success, text: 'Email is copied' });
  }, [copy, senderEmail, showGlobalMessage]);

  return (
    <>
      <WrongCountryProduct productName={productName} countryName={countryName}>
        <Typography className="Subcopy-Static">
          The sender selected a different country the gift should be send to.
          <br />
          Please get in touch with the sender to arrange for another gift.
        </Typography>
      </WrongCountryProduct>
      <Box display="flex" justifyContent="center" width="100%">
        <Box flex="1 1 auto" maxWidth="70%">
          <TextField
            value={senderEmail}
            disabled
            variant="outlined"
            data-testid="ShippingAddressForm.SenderEmail"
            fullWidth
          />
        </Box>
        <Box ml={1}>
          <StyledSubmitButton onClick={handleCopySenderEmail} data-testid="ShippingAddressForm.CopySenderEmail">
            <Box mr={1}>
              <Icon icon="copy" />
            </Box>
            Copy
          </StyledSubmitButton>
        </Box>
      </Box>
    </>
  );
};

export default memo<ICopySenderEmailFlowProps>(CopySenderEmailFlow);
